<template>
  <div>
    <SystemBar />
    <div v-if="customer && customer.email">
      <FormValidateEmail :customer="customer" />
    </div>
    <div v-else>
      <Empty @goBack="$router.replace({ path: '/' })" />
    </div>
    <OcularSign />
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    FormValidateEmail: () => import(/* webpackPrefetch: true */ '@/views/validate-email/components/FormValidateEmail.vue'),
    Empty: () => import(/* webpackPrefetch: true */ '@/views/validate-email/components/Empty.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue')
  },
  computed: {
    customer () {
      return this.$store.state.storage.room.customer
    }
  }
})
export default class Index extends Vue {}
</script>
